import Vue from 'vue'
import Vuex from 'vuex'
import { Actions } from './actions'
import { Mutations } from './mutations'
import { Getters } from './getters'
import { user } from './modules/user/index'
import { accountManager } from './modules/admin/accountManager'
import { FrontEndAppSettings } from '@models/frontEndAppSettings'
import FulfillmentCenter from './modules/fulfillmentCenter'
import AppNotificationsModule from '@/store/modules/appNotifications'
import PowerBi from './modules/powerBI'
import LoadingPromiseUtil from '@utils/loadingPromise'
import giftNotesSignup from './modules/giftNotesSignup'
import onboarding from './modules/onboarding'
import pricing from './modules/pricing'
import payment from './modules/payment'
// import orders from './modules/orders/index'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    isAdmin: null,
    authenticated: false,
    settings: FrontEndAppSettings,
    showSplashScreen: false,
    splashScreenMessage: '',
    showSideNav: false,
    browser: undefined,
    loadingPromiseUtil: new LoadingPromiseUtil(),
    cachedRoute: null
  },
  mutations: Mutations,
  actions: Actions,
  getters: Getters,
  modules: {
    user,
    accountManager,
    fulfillmentCenter: FulfillmentCenter,
    appNotifications: AppNotificationsModule,
    powerBi: PowerBi,
    giftNotesSignup,
    onboarding,
    pricing,
    payment
  }
})

if (module.hot) {
  // accept actions and mutations as hot modules
  module.hot.accept(['./mutations', './actions'], () => {
    // require the updated modules
    // have to add .default here due to babel 6 module output
    const newMutations = require('./mutations').default
    const newActions = require('./actions').default
    const newUser = require('./modules/user/index').default
    const newAccountManager = require('./modules/admin/accountManager').default
    const fulfillmentCenter = require('./modules/fulfillmentCenter').default
    const appNotifications = require('./modules/appNotifications').default
    const pricingAction = require('./modules/pricing/index').default
    const powerBi = require('./modules/powerBI').default
    // const newOrders = require('./modules/orders/index').default
    // swap in the new actions and mutations
    store.hotUpdate({
      mutations: newMutations,
      actions: newActions,
      modules: {
        user: newUser,
        accountManager: newAccountManager,
        fulfillmentCenter,
        appNotifications,
        powerBi,
        pricing: pricingAction
        // orders: newOrders
      }
    })
  })
}
